import '../styles/globals.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect, useState } from 'react';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import dynamic from "next/dynamic";
import Head from 'next/head';
const Whatsapp = dynamic(() => import("../components/whatsapp-button"));
const DelhiWhatsapp = dynamic(() => import("../components/delhi-whatsapp-button"));
import { useRouter } from 'next/router';

export default function App({ Component, pageProps }) {

  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();

  useEffect(() => {
    import("bootstrap/dist/js/bootstrap");
  }, []);
  useEffect(() => {
    console.log(router.pathname.includes("/delhi/"),router.pathname);
    if (
      window.location.href.includes("/delhi/")
    ) {
      setIsLoading(true);
      console.log(window.location.href, "whatsapp");
    }
    else if (
      window.location.href.includes("/sch-test/")
    ){
      setIsLoading(true); 
    }
    else {
      setIsLoading(false);
      console.log("jeeva");
    }
  }, [router.pathname]);


  return (
    <>

      <Head>
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-7BBP512TZQ"></script>
        <script>
          {`
                  window.dataLayer = window.dataLayer || [];
                  function gtag(){dataLayer.push(arguments);}
                  gtag('js', new Date());
                
                  gtag('config', 'G-7BBP512TZQ');
                  `}
        </script>
        {/* <script type="application/ld+json">
                      {` 
                        "@context": "https://schema.org",
                        "@type": "ItemList",
                        "itemListElement": [
                          {
                            "@type": "ListItem",
                            "position": 1,
                            "item": {
                              "@type": "course",
                              "url": "https://www.shankariasacademy.com/",
                              "name": "Best IAS Academy in Chennai | IAS & UPSC Coaching Centre in Chennai",
                              "description": "Achieve UPSC success with top coaching at the Best IAS Academy in Chennai. Expert mentors, comprehensive curriculum, and proven results.",
                              "provider": {
                                "@type": "Organization",
                                "name": "Shankar IAS Academy",
                                "sameAs": "https://www.shankariasacademy.com/"
                              },
                              "offers": {
                                "@type": "Offer", 
                                "price": "Your Price",
                                "priceCurrency": "Your Currency",
                                "category": "your category"
                            },
                            "hasCourseInstance": [
                              {
                                "@type": "CourseInstance",
                                "name": "Intro to CS - Spring 2023",
                                "startDate": "2023-01-01",
                                "endDate": "2023-04-30",
                                "location": {
                                  "@type": "Place",
                                  "name": "Online"
                                }
                              }
                            ]
                            }
                          },
                          {
                            "@type": "ListItem",
                            "position": 2,
                            "item": {
                              "@type": "course",
                              "url": "https://www.shankariasacademy.com/upsc-admission-anna-nagar/",
                              "name": "Best Online Coaching for IAS | UPSC Online Coaching | Shankar IAS Academy",
                              "description": "Shankar IAS Academy offers Online UPSC Coaching Classes and AI Based Test Series. More than 230+ classes of 150 minutes each and 100% personal assistance.",
                              "provider": {
                                "@type": "Organization",
                                "name": "Shankar IAS Academy",
                                "sameAs": "https://www.shankariasacademy.com/"
                              },
                              "offers": {
                                "@type": "Offer", 
                                "price": "Your Price",
                                "priceCurrency": "Your Currency",
                                "category": "your category"
                              },
                              "hasCourseInstance": [
                                {
                                  "@type": "CourseInstance",
                                  "name": "Intro to CS - Spring 2023",
                                  "startDate": "2023-01-01",
                                  "endDate": "2023-04-30",
                                  "location": {
                                    "@type": "Place",
                                    "name": "Online"
                                  }
                                }
                              ]
                            }
                          },
                          {
                            "@type": "ListItem",
                            "position": 3,
                            "item": {
                              "@type": "course",
                              "url": "https://www.shankariasacademy.com/upsc-interview/",
                              "name": "Free UPSC Mock Interview | UPSC Interview Guidance Programme 2023 | Shankar IAS Academy",
                              "description": "Shankar IAS Academy offers free UPSC IAS Mock Interview and Guidance Programme 2023 to all civil service aspirants who cleared UPSC mains.",
                              "provider": {
                                "@type": "Organization",
                                "name": "Shankar IAS Academy",
                                "sameAs": "https://www.shankariasacademy.com/"
                              },
                              "offers": {
                                "@type": "Offer", 
                                "price": "Your Price",
                                "priceCurrency": "Your Currency",
                                "category": "your category"
                              },
                              "hasCourseInstance": [
                                {
                                  "@type": "CourseInstance",
                                  "name": "Intro to CS - Spring 2023",
                                  "startDate": "2023-01-01",
                                  "endDate": "2023-04-30",
                                  "location": {
                                    "@type": "Place",
                                    "name": "Online"
                                  }
                                }
                              ]
                            }
                          },
                          {
                            "@type": "ListItem",
                            "position": 4,
                            "item": {
                              "@type": "course",
                              "url": "https://www.shankariasacademy.com/ifs-interview/",
                              "name": "IFS Mock Interview | UPSC IAS IPS IFS Chennai | Test Series",
                              "description": "IFS Mock Interview | Best in India for Indian Forest Service. Join Forestry Optional & Test Series, Forestry & Geology classes & Mock IFS Interview",
                              "provider": {
                                "@type": "Organization",
                                "name": "Shankar IAS Academy",
                                "sameAs": "https://www.shankariasacademy.com/"
                              },
                              "offers": {
                                "@type": "Offer", 
                                "price": "Your Price",
                                "priceCurrency": "Your Currency",
                                "category": "your category"
                              },
                              "hasCourseInstance": [
                                {
                                  "@type": "CourseInstance",
                                  "name": "Intro to CS - Spring 2023",
                                  "startDate": "2023-01-01",
                                  "endDate": "2023-04-30",
                                  "location": {
                                    "@type": "Place",
                                    "name": "Online"
                                  }
                                }
                              ]
                            }
                          },
                          {
                            "@type": "ListItem",
                            "position": 5,
                            "item": {
                              "@type": "course",
                              "url": "https://www.shankariasacademy.com/upsc-prelims-test-series/",
                              "name": "Upsc Prelims Test Series - Shankar IAS Academy",
                              "description": "ShankarIas Acadamy is the Best Ias Coaching Centre in Delhi",
                              "provider": {
                                "@type": "Organization",
                                "name": "Shankar IAS Academy",
                                "sameAs": "https://www.shankariasacademy.com/"
                              },
                              "offers": {
                                "@type": "Offer", 
                                "price": "Your Price",
                                "priceCurrency": "Your Currency",
                                "category": "your category"
                              },
                              "hasCourseInstance": [
                                {
                                  "@type": "CourseInstance",
                                  "name": "Intro to CS - Spring 2023",
                                  "startDate": "2023-01-01",
                                  "endDate": "2023-04-30",
                                  "location": {
                                    "@type": "Place",
                                    "name": "Online"
                                  }
                                }
                              ]
                            }
                          },
                          {
                            "@type": "ListItem",
                            "position": 6,
                            "item": {
                              "@type": "course",
                              "url": "https://www.shankariasacademy.com/upsc-prefit-test/",
                              "name": "The Best Coaching Centre Shankar IAS",
                              "description": "Shankar IAS Acadamy is the Best IAS Coaching Centre in Delhi and Chennai",
                              "provider": {
                                "@type": "Organization",
                                "name": "Shankar IAS Academy",
                                "sameAs": "https://www.shankariasacademy.com/"
                              },
                              "offers": {
                                "@type": "Offer", 
                                "price": "Your Price",
                                "priceCurrency": "Your Currency",
                                "category": "your category"
                              },
                              "hasCourseInstance": [
                                {
                                  "@type": "CourseInstance",
                                  "name": "Intro to CS - Spring 2023",
                                  "startDate": "2023-01-01",
                                  "endDate": "2023-04-30",
                                  "location": {
                                    "@type": "Place",
                                    "name": "Online"
                                  }
                                }
                              ]
                            }
                          },
                          {
                            "@type": "ListItem",
                            "position": 7,
                            "item": {
                              "@type": "course",
                              "url": "https://www.shankariasacademy.com/tnpsc-admissions/",
                              "name": "Best TNPSC Coaching Centre in Chennai | TNPSC Academy in Chennai | Shankar IAS Academy",
                              "description": "TNPSC Admission | We provide Best Coaching for all TNPSC Group Exam & Test Series. TNPSC Admission Group Ⅰ, Ⅱ, Ⅲ, Ⅳ & VAO Class available online, offline",
                              "provider": {
                                "@type": "Organization",
                                "name": "Shankar IAS Academy",
                                "sameAs": "https://www.shankariasacademy.com/"
                              },
                              "offers": {
                                "@type": "Offer", 
                                "price": "Your Price",
                                "priceCurrency": "Your Currency",
                                "category": "your category"
                            },
                            "hasCourseInstance": [
                              {
                                "@type": "CourseInstance",
                                "name": "Intro to CS - Spring 2023",
                                "startDate": "2023-01-01",
                                "endDate": "2023-04-30",
                                "location": {
                                  "@type": "Place",
                                  "name": "Online"
                                }
                              }
                            ]
                            }
                          },
                          {
                            "@type": "ListItem",
                            "position": 8,
                            "item": {
                              "@type": "course",
                              "url": "https://www.shankariasacademy.com/contact-us/",
                              "name": "Contact US - Shankar IAS Academy | Civil Service Examination",
                              "description": "Contact US - Shankar IAS Academy | Best UPSC, TNPSC in Anna Nagar, Adyar, Chennai, Coimbatore, Trichy, Madurai, Salem, Delhi, Bangalore, Trivandrum Online",
                              "provider": {
                                "@type": "Organization",
                                "name": "Shankar IAS Academy",
                                "sameAs": "https://www.shankariasacademy.com/"
                              },
                              "offers": {
                                "@type": "Offer", 
                                "price": "Your Price",
                                "priceCurrency": "Your Currency",
                                "category": "your category"
                              },
                              "hasCourseInstance": [
                                {
                                  "@type": "CourseInstance",
                                  "name": "Intro to CS - Spring 2023",
                                  "startDate": "2023-01-01",
                                  "endDate": "2023-04-30",
                                  "location": {
                                    "@type": "Place",
                                    "name": "Online"
                                  }
                                }
                              ]
                            }
                          }
                        ]
                        `}
                </script> */}
      </Head>


      <title>Shankar IAS Academy</title>

      <Component {...pageProps} />
      <ToastContainer
        theme='dark'
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        draggable={false}
        pauseOnVisibilityChange
        closeOnClick
        pauseOnHover
      />
      {!isLoading &&
        <Whatsapp />
      }
      {isLoading &&
        <DelhiWhatsapp />
      }
    </>)
}
